<template>
  <router-view />
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
export default {
  async created () {
    if (!this.user) {
      let tokenData = await this.getDefaultToken();
      if (tokenData) {
        this.setToken2(tokenData.access_token);
      }
    }
  },
  computed: {
    ...mapGetters({
      user: "getUser",
    }),
  },
  methods: {
    ...mapActions({
      getDefaultToken: "loginModuleFill/getDefaultToken",
    }),
    ...mapMutations({
      setToken2: "setToken2"
    }),
  }
};
</script>

<style lang="scss">
.ivu-message-custom-content {
  .ivu-icon-ios-information-circle {
    font-size: 20px;
  }
  span {
    font-size: 20px;
  }
  .ivu-icon-ios-checkmark-circle {
    font-size: 20px;
  }
}
.ivu-message-notice-close {
  top: 16px;
}
</style>
